import pick from 'lodash/pick'

// Cuentas disponibles para el select
const accounts = [
  {
    id: "e42d1116-247d-4bf7-8000-d56980901d8e",
    name: "Cuenta 1"
  },
  {
    id: "a51d1118-247d-4bf7-8000-a56980901d8f",
    name: "Cuenta 2"
  }
]

const collection = [
  {
    id: "38156ba0-06d2-4e77-b17b-03b9bdbbe1e3",
    firstName: "Manuela",
    lastName: "Garcia",
    fullName: "Manuela Garcia",
    email: "manuela.garcia@grupomarktel.com",
    phone: "",
    status: 1,
    roleId: "fe745357-6c7d-4cec-88b2-88a68399d7b0",
    avatarUrl: "",
    accountId: "e42d1116-247d-4bf7-8000-d56980901d8e",
    accountName: "Cuenta 1"
  },
  {
    id: "d1ebf49c-18bc-44a0-b115-1d1f91621e8a",
    firstName: "Leonardo",
    lastName: "Quinones",
    fullName: "Leonardo Quinones",
    email: "leonardo.quinones2@calimatechnologies.com",
    phone: "",
    status: 1,
    roleId: "fe745357-6c7d-4cec-88b2-88a68399d7b0",
    avatarUrl: "",
    accountId: "a51d1118-247d-4bf7-8000-a56980901d8f",
    accountName: "Cuenta 2"
  },
  {
    id: "c8ed950b-2317-4eb1-968a-2b6b607a92b2",
    firstName: "Natalia",
    lastName: "León",
    fullName: "Natalia León",
    email: "natalia.leon@grupomarktel.com",
    phone: "",
    status: 1,
    roleId: "fe745357-6c7d-4cec-88b2-88a68399d7b0",
    avatarUrl: "",
    accountId: "e42d1116-247d-4bf7-8000-d56980901d8e",
    accountName: "Cuenta 1"
  }
]

// 📌 Devuelve toda la colección sin filtros
const showSuperadmin = collection

// 📌 Devuelve solo los campos necesarios para el listado
const indexSuperadmin = collection.map(item =>
  pick(item, [
    "id",
    "firstName",
    "lastName",
    "fullName",
    "email",
    "phone",
    "status",
    "roleId",
    "avatarUrl",
    "accountId",
    "accountName"
  ])
)

const validations = {
  firstName: { type: "string", required: true, maxLength: 64 },
  lastName: { type: "string", required: true, maxLength: 64 },
  email: { type: "string", required: true, format: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ },
  status: { type: "number", required: true, enum: [0, 1] },
  accountId: { type: "string", required: true }
}


export {
  accounts,
  showSuperadmin,
  indexSuperadmin,
  validations
}
